import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconLikeOutline: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" boxSize={3} {...props}>
        <path
            d="m6.9965 9h-2.9995c-1.1024 0-1.997 0.89289-1.997 1.9961v8.1074c0 1.1201 0.90271 1.8965 1.997 1.8965h2.0017c1.1035 0 1.9978-0.89697 1.9978-2v-9c0-0.55228-0.44772-1-1-1zm-2.9965 2h1.996l0.0026661 8h-1.9987v-8z"
            fill="currentColor"
            fillRule="nonzero"
        />
        <path
            d="m11.838 2h-0.838c-0.55228 0-1 0.44772-1 1v4c0 1.4117-0.59698 2-2 2h-1.0035c-0.55228 0-1 0.44772-1 1v9.203c0 1.5419 1.4965 2.797 3.0327 2.797h8.4068c1.2875 0 2.396-0.90774 2.6816-2.1775l1.8132-8.0959 0.032625-0.16868c0.27434-1.6837-0.99652-3.2579-2.7135-3.2579l-3.79-1e-3 1e-3 -2.597c0-2.0379-1.6151-3.702-3.623-3.702zm0.162 2.009 0.11309 0.015455c0.76087 0.13671 1.3479 0.83067 1.3479 1.6775v3.598c0 0.55228 0.44772 1 1 1h4.789c0.47571 0 0.84401 0.47699 0.7292 0.98933l-1.813 8.0951c-0.082179 0.36534-0.38773 0.61555-0.73017 0.61555h-8.4068l-0.10778-0.0066179c-0.46719-0.056504-0.9249-0.4637-0.9249-0.79038l-5.0002e-4 -8.203c2.5051 0 4.004-1.4772 4.004-4v-2.991z"
            fill="currentColor"
            fillRule="nonzero"
        />
    </Icon>
);
